export default {
  base:{
    nextLanguage:'Switching to English'
  },
  myself:{
    ecard: '电子卡片',
    order: '我的订单',
    mydivecenter: '我的潜水中心',
    address: '收货地址管理',
    student: '学员信息管理',
    jobs: '工作机会',
    helper: '帮助中心',
    about: '关于',
    loginout: '退出登录'
  },
  diveCenter: {
    sport: {
      sno: '浮潜',
      xr: '技术潜水',
      emergency: '技术潜水',
      ecology: '生态',
      scuba: '水肺潜水',
      freediving: '自由潜水',
      mermaid: '美人鱼',
      swim: '泳池',
      rebreather: '适应性潜水',
      instructor_training: '教练培训'
    }
  },
  diveType: {
    scubadiving: '水肺潜水',
    ecologyandreactright: '生态',
    freediving: '自由潜水',
    generalssi: '普通',
    snorkeling: '浮潜'
  }
}

